import { combineReducers } from 'redux';
import Issues from './detailedIssesDucks';
import TOC from '../Tabs/TOC/redux/tocDucks';

export default combineReducers({
  TOC,
  Issues,
});
